module.exports = "/static/Images/pt-br/Ten.png";